import { render, staticRenderFns } from "./VisitTable.vue?vue&type=template&id=21fa4648&scoped=true"
import script from "./VisitTable.vue?vue&type=script&lang=js"
export * from "./VisitTable.vue?vue&type=script&lang=js"
import style0 from "./VisitTable.vue?vue&type=style&index=0&id=21fa4648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa4648",
  null
  
)

export default component.exports